import { FONT_FACE_CALIBRI, FONT_FACE_DAGNY_DISPLAY, FONT_FACE_DAGNY_TEXT, FONT_FACE_NITTI_GROTESK_NN_HEADING, FONT_FACE_NITTI_GROTESK_NN_TEXT_BOLD, FONT_FACE_NITTI_GROTESK_NN_TEXT_MEDIUM, FONT_FACE_NITTI_GROTESK_NN_TEXT_REGULAR, } from '../constants';
// @see https://learn.microsoft.com/en-us/typography/opentype/otspec183/os2#usweightclass
const FONT_WEIGHT_NORMAL = '400';
const FONT_WEIGHT_MEDIUM = '500';
const FONT_WEIGHT_BOLD = '700';
/**
 * Font files can contain variants (regular, italic, bold, bold italic, and custom ones).
 * If a font weight is used with a font, the closest weight of an existing variant is chosen.
 * The Nitti Grotesk NN Text Medium contains 2 variants. If we choose font weight normal we will get a regular looking result instead of the intended medium.
 * This transformer returns a specific font weight that matches the font file.
 */
export function transformFontWeight(fontWeight, fontFamily) {
    // The injected font family may already contain alternative fallback font families
    const primaryFontFamily = fontFamily.split(',')[0];
    if (primaryFontFamily === FONT_FACE_CALIBRI) {
        return fontWeight;
    }
    const value = new Map()
        .set(FONT_FACE_DAGNY_DISPLAY, FONT_WEIGHT_MEDIUM) // Needs to be medium for Android
        .set(FONT_FACE_DAGNY_TEXT, FONT_WEIGHT_NORMAL)
        .set(FONT_FACE_NITTI_GROTESK_NN_HEADING, FONT_WEIGHT_BOLD)
        .set(FONT_FACE_NITTI_GROTESK_NN_TEXT_REGULAR, FONT_WEIGHT_NORMAL)
        .set(FONT_FACE_NITTI_GROTESK_NN_TEXT_MEDIUM, FONT_WEIGHT_MEDIUM)
        .set(FONT_FACE_NITTI_GROTESK_NN_TEXT_BOLD, FONT_WEIGHT_BOLD)
        .get(primaryFontFamily);
    if (!value) {
        throw new Error('Unknown font family supplied!');
    }
    return value;
}
